import React, { Component } from 'react';

import { Form } from 'react-final-form'
import arrayMutators from 'final-form-arrays'
import { FieldArray } from 'react-final-form-arrays'
import setFieldData from 'final-form-set-field-data'

import {
  Typography,
  Paper,
  Grid,
  Button,
  CircularProgress,
} from '@material-ui/core';

import {
  formInput,
  formRadio,
  formTextarea,
  formDate,
} from '../components/FormFields';
import './Enroll.css';
import AutoSave from '../components/Autosave'
import EnrollDescription from './Enroll-description';

import metadata from '../metadata';

// const validate = values => {
//   const errors = {};
//   if (!values.firstName) {
//     errors.firstName = 'Required';
//   }
//   if (!values.lastName) {
//     errors.lastName = 'Required';
//   }
//   if (!values.email) {
//     errors.email = 'Required';
//   }
//   return errors;
// };

const relationshipOptions = [
  { value: 'father', label: 'Father' },
  { value: 'mother', label: 'Mother' },
  { value: 'grandfather', label: 'Grandfather' },
  { value: 'grandmother', label: 'Grandmother' },
  { value: 'uncle', label: 'Uncle' },
  { value: 'auntie', label: 'Aunt' },
  { value: 'legalGuardian', label: 'Legal Guardian' },
];

const MAX_CAMPERS = 4;

export default class Enroll extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      hasEnded: ((new Date(metadata.deadline).getTime() + 86400000) <= Date.now()),
    }
    this.storageKey = 'scccs-summercamp-application';

    this.onSubmit = this.onSubmit.bind(this);
    this.save = this.save.bind(this);
  }

  load() {
    const params = new URLSearchParams(this.props.location.search);
    const id = params.get('id');
    if (id) {
      return this.loadFromServer(id);
    } else {
      return this.loadFromLocalStorage();
    }
  }

  loadFromServer(id) {
    return Promise.resolve()
      .then(() => {
        const url = `${metadata.apiUrl}/enrollment/${id}`;
        const params = {
          method: 'GET',
          mode: 'cors',
          headers: {
            'x-api-key': metadata.apiKey,
          },
        };
        return fetch(url, params).then((response) => {
          if (response.status !== 200) {
            return Promise.reject(response);
          }
          return response.json();
        })
      })
      .then((res) => {
        this.setState({
          loading: false,
          data: res.data,
        });
      })
      .catch((err) => {
        return this.loadFromLocalStorage();
      });
  }

  loadFromLocalStorage() {
    let data = {};
    try {
      data = JSON.parse(localStorage.getItem(this.storageKey)) || {};
      data.campers = data.campers || [{ allergyApplied: 'no' }];
    } catch (e) {
      // 
      console.log(e);
    }

    // delete signature
    delete data.waiverLiability;
    delete data.waiverPhotoRelease;

    this.setState({
      loading: false,
      data
    });
  }

  save(inValues = {}) {
    try {
      let currentData = JSON.parse(localStorage.getItem(this.storageKey)) || {};
      const toSaveData = Object.assign(currentData, inValues);
      // console.log('saving data', toSaveData);
      localStorage.setItem(this.storageKey, JSON.stringify(toSaveData));
    } catch (e) {
      // 
      console.log(e);
    }
  }

  alert(msg) {
    return new Promise((resolve, reject) => {
      const r = window.confirm(msg);
      return (r) ? resolve() : reject();
    });
  }

  reset() {
    localStorage.setItem(this.storageKey, JSON.stringify({}));
  }

  resetConfirm(form) {
    this.alert('Do you want to reset the whole application form?')
      .then(() => {
        if (form && form.reset) {
          form.reset();
        }
        this.reset();
        this.load();
        this.save();
      })
      .catch(() => {})
  }

  componentDidMount() {
    this.load();
  }

  onSubmit(values) {
    return Promise.resolve()
      .then(() => {
        const url = `${metadata.apiUrl}/enrollment`;
        const params = {
          method: 'POST',
          mode: 'cors',
          headers: {
            'x-api-key': metadata.apiKey,
          },
          body: JSON.stringify(values),
        };
        return fetch(url, params).then((response) => {
          if (response.status !== 200) {
            return Promise.reject(response);
          }
          return response.json();
        })
      })
      .then((res) => {
        // // save the id to localstorage
        // this.save(res.data);
        this.reset();
        window.open(`/enrollCompleted?id=${res.data.id}&autoDownload=true`, '_self');
        // return generateAndDownloadForms(values)
        //   .then(() => {
        //   })
      })
      .catch(console.log);
  }

  render() {
    return (
      <Grid container className="main" justify="center">
        <Grid item xs={12} sm={10} md={8}>
        <EnrollDescription/>
        
        {this.state.loading && 
          <Grid item xs={12} align="center">
            <CircularProgress />
          </Grid>}

        {!this.state.loading && this.state.hasEnded &&
          <p>
            Registration has ended at {metadata.deadline}
          </p>
        }

        {!this.state.loading && !this.state.hasEnded &&
        <Form
          onSubmit={this.onSubmit}
          mutators={{ setFieldData, ...arrayMutators }}
          // validate={validate}
          initialValues={this.state.data}
          render={({
            handleSubmit,
            pristine,
            form,
            submitting,
            // validating,
            values,
          }) => {
            return (
              <form onSubmit={handleSubmit}>
                <AutoSave debounce={3000} save={this.save} />

                <FieldArray name="campers">
                  {({ fields }) =>
                    fields.map((name, index) => (
                      <Paper key={name} className="paper-container">
                        <Grid container alignItems="flex-start" spacing={8} >
                          <Grid item xs={8}>
                            <Typography variant="h5">Camper #{index + 1}</Typography>
                          </Grid>
                          {(index === 0)? '': (
                            <Grid item xs={4} align="right">
                              <Button
                                variant="outlined"
                                color="secondary"
                                onClick={() => {
                                  this.alert('Do you want to remove this camper?')
                                    .then(()=>{
                                      fields.remove(index)
                                    })
                                    .catch(()=>{})
                                }}
                                >
                                Remove
                              </Button>
                            </Grid>
                          )}
                        </Grid>
                        <hr></hr>

                        <Grid container alignItems="flex-start" spacing={8}>
                          <Grid item xs={12}>
                            {formInput(`${name}.chineseName`, 'Chinese Name (中文名)', false, 'Please write in Chinese 請用中文寫中文名')}
                          </Grid>
                          <Grid item xs={12}>
                            {formInput(`${name}.firstName`, 'First Name')}
                          </Grid>
                          <Grid item xs={12}>
                            {formInput(`${name}.lastName`, 'Last Name')}
                          </Grid>
                          <Grid item xs={12}>
                            {formInput(`${name}.nickname`, 'Nickname', false, 'complete only if different from name above. This will also appear in our Program Book')}
                          </Grid>
                          <Grid item xs={12}>
                            {formDate(`${name}.birthday`, 'Date of Birth (MM/DD/YYYY)')}
                          </Grid>
                          {/* <Grid item xs={12} md={6}>
                            {formInput(`${name}.age`, 'Age as of 06/01', false, 'Please fill the Date of Birth', true)}
                          </Grid> */}
                          <Grid item xs={12} md={6}>
                            {formInput(`${name}.height`, 'Height (feet & inches)')}
                          </Grid>
                          <Grid item xs={12} md={6}>
                            {formInput(`${name}.weight`, 'Weight (lbs)')}
                          </Grid>
                          <Grid item xs={12} md={6}>
                            {formRadio(`${name}.gender`,'Gender', true, [
                              { value: 'male',   label: 'Male' },
                              { value: 'female', label: 'Female' }
                            ])}
                          </Grid>
                          <Grid item xs={12} md={6}>
                            {formRadio(`${name}.tShirtSize`,'T-shirt Size', true, [
                              { value: 'child-M', label: 'Child M' },
                              { value: 'child-L', label: 'Child L' },
                              { value: 'adult-M', label: 'Adult M' }
                            ])}
                          </Grid>
                          {/* <Grid item xs={12}>
                            {formCheckbox(`${name}.liveWith`,'Currently lives with?', true, relationshipOptions)}
                          </Grid> */}
                          {/* <Grid item xs={12}>
                            {formTextarea(`${name}.notes`, 'Notes', false)}
                          </Grid> */}
                          <Grid item xs={12}>
                            {formRadio(`${name}.attendSummercampBefore`, 'Have you ever attended the summer camp?', true, [
                              { value: 'no', label: 'No. This is my first time attending the camp' },
                              { value: 'yes', label: 'Yes. I have attended before.' },
                              { value: 'yes-asConselor', label: 'Yes. I have served as a Vice Counselor before.' },
                            ])}
                          </Grid>
                        </Grid>

                        <Typography variant="h6">Current School</Typography>
                        <hr/>
                        <Grid container alignItems="flex-start" spacing={8}>
                          <Grid item xs={12} md={6}>
                            {formInput(`${name}.currentSchoolName`, 'Currently attending which regular School?')}
                          </Grid>
                          <Grid item xs={12} md={6}>
                            {formInput(`${name}.currentSchoolCity`, 'In which city?')}
                          </Grid>
                          <Grid item xs={12} md={6}>
                            {formInput(`${name}.currentSchoolGrade`, 'Current School Grade')}
                          </Grid>
                        </Grid>

                        <Typography variant="h6">Chinese School</Typography>
                        <hr/>
                        <Grid container alignItems="flex-start" spacing={8}>
                          <Grid item xs={12} md={6}>
                            {formInput(`${name}.chineseSchoolName`, 'Which Chinese School are you attending?', true, '中文學校名. If none, write N/A')}
                          </Grid>
                          <Grid item xs={12} md={6}>
                            {formInput(`${name}.currentSchoolAddress`, 'Chinese School Address')}
                          </Grid>
                          <Grid item xs={12} md={6}>
                          </Grid>
                          <Grid item xs={12} md={6}>
                          </Grid>
                        </Grid>

                        <Typography variant="h6">Allergy</Typography>
                        <hr/>
                        <Grid container alignItems="flex-start" spacing={8}>
                          <Grid item xs={12}>
                            {formRadio(`${name}.allergyApplied`, 'Allergy?', true, [
                              { value: 'no', label: 'No' },
                              { value: 'yes', label: 'Yes' },
                            ])}
                          </Grid>
                          <Grid item xs={12}>
                              {formInput(
                                `${name}.allergyMedication`,
                                'My child is allergic to xxx and is currently taking this medication', 
                                false, 
                                '',
                                !values.campers[index] || values.campers[index].allergyApplied === 'no')}
                            </Grid>
                            <Grid item xs={12}>
                              {formRadio(
                                `${name}.allergyAction`,
                                'Administering Allergy Medication',
                                true,
                                [
                                  // { value: 'N/A', label: 'NONE' },
                                  { value: 'My child can take his/her own medication', label: 'My child can take his/her own medication' },
                                  { value: 'I will provide this medication to the Nurse on the first day of camp.', label: 'I will provide this medication to the Nurse on the first day of camp.' },
                                ], 
                                '', 
                                !values.campers[index] || values.campers[index].allergyApplied === 'no'
                              )}
                            </Grid>
                        </Grid>

                        <Typography variant="h6">Other</Typography>
                        <hr/>
                        <Grid container alignItems="flex-start" spacing={8}>
                          <Grid item xs={12}>
                            {formRadio(`${name}.campViceCounselorPosition`, 'Vice Counselor Position?', true, [
                              { value: 'no', label: 'No. I wish to attend as a regular camper' },
                              { value: 'yes', label: 'Yes. I wish to be considered for Vice Counselor position. I still want to attend camp even if I am not chosen to be Vice Counselor' },
                              { value: 'yes-butNotAttendIfNotSelected', label: 'Yes. I wish to be considered for Vice Counselor position. I DO NOT WISH TO ATTEND SUMMER CAMP if I am not selected for Vice Counselor' },
                            ])}
                          </Grid>
                        </Grid>

                        <Typography variant="h6">Special Requests</Typography>
                        <hr/>
                        <Grid container alignItems="flex-start" spacing={8}>
                          <Grid item xs={12}>
                            {formTextarea(`${name}.roomWith`, 'If you would like to room with another camper?')}
                          </Grid>
                        </Grid>
                      </Paper>
                    ))}
                </FieldArray>
                
                {values.campers.length < MAX_CAMPERS && 
                  <Grid container alignItems="flex-start" spacing={8} style={{ 'marginTop': '20px' }}>
                    <Grid item xs={12} align="center">
                      <Button
                          onClick={() => form.mutators.push('campers', { allergyApplied: 'no'})}
                          variant="outlined"
                          color="primary"
                          >
                          Add a new camper
                        </Button>
                    </Grid>
                  </Grid>
                }

                <Paper className="paper-container">
                  <Typography variant="h5">Primary Contact</Typography>
                  <hr></hr>
                  <Grid container alignItems="flex-start" spacing={8}>
                    <Grid item xs={12} md={6}>
                      {formInput('firstName', 'First Name')}
                    </Grid>
                    <Grid item xs={12} md={6}>
                      {formInput('lastName', 'Last Name')}
                    </Grid>
                    <Grid item xs={12}>
                      {formInput('email', 'Email')}
                    </Grid>
                    <Grid item xs={12}>
                      {formInput('primaryPhone', 'Primary Cell Phone', true, '', false, 'phone')}
                    </Grid>
                    <Grid item xs={12}>
                      {formInput('secondaryPhone', 'Secondary Cell Phone (in case unable to contact the primary cell phone)', true, '', false, 'phone')}
                    </Grid>
                    <Grid item xs={12}>
                      {formRadio(`relationShip`,'Relationship', true, relationshipOptions)}
                    </Grid>
                  </Grid>

                  <Typography variant="h6">Home Address</Typography>
                  <hr/>
                  <Grid container alignItems="flex-start" spacing={8}>
                    <Grid item xs={12}>
                      {formInput('address.street', 'Street')}
                    </Grid>
                    <Grid item xs={12} md={4}>
                      {formInput('address.city', 'City')}
                    </Grid>
                    <Grid item xs={12} md={4}>
                      {formInput('address.state', 'State')}
                    </Grid>
                    <Grid item xs={12} md={4}>
                      {formInput('address.zipCode', 'Zip Code')}
                    </Grid>
                  </Grid>
                </Paper>

                <Paper className="paper-container">
                  <Typography variant="h5">RELEASE AND WAIVER OF LIABILITY AND INDEMNITY AGREEMENT AUTHORIZATION FOR EMERGENCY/MEDICAL CARE AND CLAIM WAIVER</Typography>
                  <hr></hr>
                  <Grid container alignItems="flex-start" spacing={8}>
                    <Grid item xs={12}>
                    <p>
                      YMCA Camp Oakes does not provide health care or medical assistance.
                      SCCCS will have an on-site nurse to handle minor injuries or high altitude nose bleeds, vomiting, fevers….
                    </p>
                    <p>
                      I/We <b><u>{values.firstName} {values.lastName}</u></b> request that the above-mentioned applicant be permitted to participate in the Chinese Cultural Youth Summer Camp sponsored
                      by the Southern California Council of Chinese Schools (SCCCS). He/She is in good/ excellent physical condition.
                      Should he/she become ill or injured at the camp and may receive necessary first aid or medical attention by a licensed physician or
                      nurse, or be admitted to a hospital in case of an emergency. This authorization is given pursuant to Section 25.8 of Civil Code of
                      California and remains effective only for the event and time period specified above. 
                    </p>
                    <p>
                      I/We <b><u>{values.firstName} {values.lastName}</u></b> will not hold YMCA Camp Oakes, YMCA organization, SCCCS or its officers, teachers, counselors, Guardians and
                      helpers liable or responsible for the above activities and medical aid rendered. I understand these activities are voluntary, and
                      he/she has my permission to participate in it. I also understand that there are certain risks involved in these activities, including, but
                      not limited to, accidents, injuries, illness or death while traveling to and from said activity, and/or in the course of the activities,
                      and/or the potential for property damage and/or loss. I/WE WILL BE 100% RESPONSIBLE FOR MY/OUR OWN HEALTH
                      INSURANCE DEDUCTIBLES, Copays and CO-INSURANCE.
                    </p>
                    <p>
                      I will reimburse SCCCS for medical or other expenses incurred for his/her care. <br/>
                      My child(ren) is(are) restricted from the following activities: <br/>
                    </p>

                    {formInput(`waiverLiabilityRestrictActivities`, 'Restricted Activities', false)}

                    <p>
                      While we respect your privacy, it is important that parents/guardians to advise SCCCS Summer Camp staff of certain conditions
                      which may affect their child’s ability to participate in a group environment and to sleep in the dorms with other students, so that we
                      are better prepared to address the situation including, but not limited to, Autism, Attention-Deficit Hyperactivity Disorder
                      (ADHD), Special Ed Students, other special conditions:
                    </p>
                    <p>
                      SCCCS cannot provide one-on-one care to campers. Please contact us first ({metadata.contact.email}) if you have any questions before submitting application.
                    </p>
                    <ol>
                      {
                        (values && Array.isArray(values.campers))?
                          values.campers.map((camper, index)=>{
                            return (<li key={index}>
                              {camper.firstName} {camper.lastName}
                            </li>)
                          }) : ''
                      }
                    </ol>
                    </Grid>
                    <Grid item xs={12}>
                      <p>By typing my name below, I/we agree to all the above-referenced terms.</p>
                      <br/>
                      {formInput(`waiverLiability`, 'E-Signature')}
                    </Grid>
                  </Grid>
                </Paper>

                <Paper className="paper-container">
                  <Typography variant="h5">PHOTOGRAPHY RELEASE</Typography>
                  <hr></hr>
                  <Grid container alignItems="flex-start" spacing={8}>
                    <Grid item xs={12}>
                    <p>
                      I/We hereby authorize SCCCS Chinese Cultural Youth Summer Camp officials, hereafter referred to as “SCCCS” to the right to take photographs of me and my family in connection with SCCCS activities. I authorize SCCCS, its assigns and transferees to copyright, use and publish the same in print and/or electronically for any lawful purpose. I hereby release and hold harmless SCCCS from any reasonable expectation of privacy or confidentiality for myself and for the minor child and children listed below associated with the images specified above. Further, I attest that I am the parent or legal guardian of the child or children listed below and that I have full authority to consent and authorize SCCCS to use their likenesses and names including social medias such as Facebook.
                    </p>
                    <p>
                      We further acknowledge that participation is voluntary and that neither I, the minor child, or minor children will receive financial compensation of any type associated with the taking or the publishing of these photographs. I acknowledge and agree that publication of said photos confers no rights of ownership or royalties whatsoever. I hereby release SCCCS, its contractors, its volunteers and any third parties involved in taking or publishing photographs, from liability for any claims by me or any third party in connection with my participation or the participation of the minor children listed below. 
                    </p>
                    <ol>
                      {
                        (values && Array.isArray(values.campers))?
                          values.campers.map((camper, index)=>{
                            return (<li key={index}>
                              {camper.firstName} {camper.lastName}
                            </li>)
                          }) : ''
                      }
                    </ol>
                    </Grid>
                    <Grid item xs={12}>
                      <p>By typing my name below, I/we agree to all the above-referenced terms.</p>
                      <br/>
                      {formInput(`waiverPhotoRelease`, 'E-Signature')}
                    </Grid>
                  </Grid>
                </Paper>

                <Grid container alignItems="flex-start" spacing={8} style={{ 'marginTop': '20px' }}>
                  <Grid item xs={12} align="center">
                    {/* <Button 
                      variant="outlined"
                      color="primary"
                      onClick={()=>{
                        generateAndDownloadForms(values);
                      }}                      >
                      Download Forms (test)
                    </Button>
                    &nbsp; */}
                    <Button 
                        variant="contained"
                        color="primary"
                        type="submit"
                        disabled={submitting || pristine}
                        >
                        Submit Application
                      </Button>
                      &nbsp;
                      <Button
                        variant="outlined"
                        color="secondary"
                        onClick={()=>{
                          this.resetConfirm(form);
                        }}
                        disabled={submitting}
                        >
                        Reset
                      </Button>
                  </Grid>
                </Grid>

                {/* <pre>{JSON.stringify((values || {}), 0, 2)}</pre> */}
              </form>
            )
          }}
        />}
        </Grid>
    </Grid>);
  }
}
